/**
 * Simulate a change event on the targetted input element.
 * Unlike `element.value = "123"', this will correctly trigger any react onChange handlers that might be attached to it
 */
export function fakeChangeEvent(
  inputElement: HTMLInputElement | HTMLSelectElement,
  newValue: string,
) {
  const prototype =
    inputElement instanceof window.HTMLInputElement
      ? window.HTMLInputElement.prototype
      : window.HTMLSelectElement.prototype;
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    prototype,
    'value',
  )!.set;
  nativeInputValueSetter!.call(inputElement, newValue);
  inputElement.dispatchEvent(new window.Event('change', { bubbles: true }));
}

/**
 * Prepend text to an input while mainaining the current cursor/selection position
 */
export function prependToInput(input: HTMLInputElement, prefix: string) {
  const start = input.selectionStart ?? input.value.length;
  const end = input.selectionEnd ?? input.value.length;
  const direction = input.selectionDirection;

  // eslint-disable-next-line no-param-reassign
  input.value = `${prefix}${input.value}`;
  if (direction) {
    input.setSelectionRange(
      start + prefix.length,
      end + prefix.length,
      direction,
    );
  }
}
